import useItems from "../../../api/useItems";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

export default function ItemPickerField({
  name = "",
  value = "",
  onChange,
  error = false,
  helperText = "",
  label = "State",
  required = false,
  fullWidth = true,
  therapy = null,
  itemType = null,
  ...otherProps
}) {
  const { isLoading, error: fetchError, data } = useItems(therapy, itemType);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  const labelId = `${name}-item-list`;

  return (
    <FormControl fullWidth={fullWidth} error={error} required={required}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value}
        onChange={handleChange}
        {...otherProps}
      >
        <MenuItem value="">
          <em>
            {isLoading
              ? "Loading..."
              : fetchError
              ? "Fetch error..."
              : "Select an item"}
          </em>
        </MenuItem>
        {data &&
          data.map((i) => (
            <MenuItem key={i.id} value={i.id}>
              {i.hlabel} ({i.model_number})
            </MenuItem>
          ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
